import React from 'react'
import { M_Table } from 'src/components/M_Components'

export default function Costs({ roles }) {

    return (
            <M_Table entityName={'Costs'} filtersOnTable rolePermissions={roles} />
    )
}